module.exports = __webpack_public_path__ + "media/svg-new/spider-3-a21e49e8.svg";